const routes = [
    {
        "url" : "/",
        "name":"Home",
        "id":1
    },
    {
        "url" : "/events",
        "name":"Events",
        "id":2
    },
    {
        "url" : "/teams",
        "name":"Our Team",
        "id":3
    },

];
export default routes;